import { Component, Ref, Prop, PropSync, Mixins } from 'vue-property-decorator';
import * as _ from 'lodash';
import { withParams } from 'vuelidate';
import { TjipFormControlValueMixin, TjipFormItemTextMixin } from '@tjip/vuejs';
import { AppFormItemFileUploadMixin } from './AppFormItemFileUploadMixin';

const dropAllowedClass = 'drop-allowed';
const dropDeniedClass = 'drop-denied';

@Component({
  components: {},
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  validations: AppFormControlFileUploadComponent.validations
})
export class AppFormControlFileUploadComponent extends Mixins(
  TjipFormControlValueMixin,
  TjipFormItemTextMixin,
  AppFormItemFileUploadMixin
) {
  private static validations(this: AppFormControlFileUploadComponent) {
    return {
      value: {
        mimetype: () => {
          const result = !this.files.find(val => {
            return !(!val || !this.acceptedMimeTypes || _.includes(this.acceptedMimeTypes.split(','), val.type));
          });
          return result;
        },
        maxSize: withParams(
          {
            type: 'maxSize',
            max: this.resolvedMaxUploadSize
          },
          () => {
            const result = !this.files.find(val => {
              return !(!val || val.size < this.resolvedMaxUploadSize);
            });
            return result;
          }
        ),
        maxCount: withParams(
          {
            type: 'maxCount',
            max: this.maximum
          },
          () => {
            return !this.maximum || this.files.length <= this.maximum;
          }
        )
      }
    };
  }

  @Prop()
  public id!: string;
  @Prop()
  public value!: File[];
  @PropSync('isActive')
  public syncedIsActive!: boolean;
  @Ref('fileInput')
  private fileInputCtrl!: HTMLElement;

  public get inputId(): string {
    return `doc_${(this.resolvedId || '').replace(/\./g, '_')}`;
  }

  public get dropId(): string {
    return `drop_${(this.resolvedId || '').replace(/\./g, '_')}`;
  }

  public get resolvedButtonClass(): string {
    return this.buttonClass || 'btn-secondary';
  }

  public get resolvedMaxUploadSize(): number {
    return this.maxSize || 70 * 1024 * 1024; // 70MB
  }

  private get files(): File[] {
    return this.internalValue || ([] as File[]);
  }

  public get resolvedPlaceholder(): string {
    const result =
      this.files && this.files.length
        ? this.files.length === 1
          ? this.files[0].name
          : `${this.files.length} documenten geselecteerd`
        : this.placeholder || `selecteer document${this.multiple ? '(en)' : ''}`;
    this.$log.debug(result, this.files);
    return result;
  }

  public selectFiles() {
    this.fileInputCtrl.click();
  }

  public filesSelected(event: Event) {
    const target = event.target as any;
    if (target && target.files) {
      let changed = false;
      target.files.forEach((f1: File) => {
        if (!this.files.find(f2 => f2.name === f1.name && f2.lastModified === f1.lastModified)) {
          changed = true;
          this.files.push(f1);
        }
      });
      // clear input type="file" used for file open dialog
      target.value = '';
      if (changed) {
        this.$emit('input', this.files);
      }
    }
  }

  public removeFile(file: File) {
    const ndx = this.files.indexOf(file);
    if (ndx >= 0) {
      this.files.splice(ndx, 1);
      this.$emit('input', this.files);
    }
  }

  // public inputFilter(newFile: VUFile, oldFile: VUFile, prevent: Function) {
  //   if (newFile) {
  //     this.serverError = false;
  //     Object.assign(newFile.headers, this.headers);
  //     if (!oldFile && prevent) {
  //       let isPrevented = false;
  //       const wrappedPrevent = () => {
  //         isPrevented = true;
  //         prevent();
  //       };
  //       this.$emit('inputFilter', wrappedPrevent);
  //       if (!isPrevented) {
  //         this.files.push(newFile);
  //         this.$emit('input', this.files);
  //       }
  //     }
  //   }
  // }

  public clear() {
    this.files.splice(0, this.files.length);
    this.$emit('input', this.files);
    this.$v.$reset();
  }

  protected mounted() {
    this.$nextTick(() => {
      this.registerDragEvents();
    });
  }

  protected beforeDestroy() {
    this.unregisterDragEvents();
  }

  private registerDragEvents() {
    // const d = this.dropElement;
    // if (d) {
    //   d.addEventListener('dragleave', this.onDragLeave);
    //   d.addEventListener('dragover', this.onDragOver);
    //   d.addEventListener('drop', this.onDrop);
    // }
  }

  private unregisterDragEvents() {
    // const d = this.dropElement;
    // if (d) {
    //   d.removeEventListener('dragleave', this.onDragLeave);
    //   d.removeEventListener('dragover', this.onDragOver);
    //   d.removeEventListener('drop', this.onDrop);
    // }
  }

  public onDragLeave() {
    this.setDropClass();
  }

  public onDragOver(event: any) {
    const transfer = event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
    if (transfer) {
      transfer.dropEffect = 'copy';
      event.preventDefault();
      event.stopPropagation();
      this.setDropClass(dropAllowedClass);
    } else {
      this.setDropClass(dropDeniedClass);
    }
  }

  public onDrop() {
    this.clear();
    this.setDropClass();
  }

  private setDropClass(className?: string) {
    // const d = this.dropElement;
    // if (d) {
    //   _.forEach(
    //     _.filter([dropAllowedClass, dropDeniedClass], c => c !== className),
    //     c => d.classList.remove(c)
    //   );
    //   if (className) {
    //     d.classList.add(className);
    //   }
    // }
  }
}

export default AppFormControlFileUploadComponent;
